<div class="wrap">
  <h2>Dupliquer une offre</h2>

  <ng-container *ngIf="!isLoadingPicture">
    <p>Vous souhaitez dupliquer une offre à destination du club
      <ng-container *ngIf="userConnected.role === 'AdminMSR'">
        <b>{{userConnected.club_code}}</b> :
      </ng-container>

      <ng-container *ngIf="userConnected.role === 'admin'">
        suivant :
      </ng-container>
    </p>

    <form [formGroup]="duplicateOfferForm">
      <div class="input">
        <mat-form-field appearance="outline">
          <mat-label>N° Club</mat-label>
          <mat-select formControlName="clubCode">
            <mat-option *ngFor="let c of clubs" [value]="c.code"> <strong>{{c.code}}</strong> - {{c.name}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Nom de la nouvelle offre</mat-label>
          <input type="text" matInput formControlName="offerName">
        </mat-form-field>
      </div>

      <div class="btn_action">
        <button type="button" class="back" (click)="dialogRef.close()">Annuler</button>
        <button type="button" class="confirm" (click)="duplicateOffer()"
          [style.opacity]="duplicateOfferForm.invalid || duplicateOfferForm.pristine || isLoadingCreation ? .5 : 1"
          appChangeColorTheme attribute="bgc"
          [disabled]="duplicateOfferForm.invalid || duplicateOfferForm.pristine || isLoadingCreation">Dupliquer</button>
      </div>
    </form>
  </ng-container>

  <mat-spinner *ngIf="isLoadingPicture" [diameter]="50" color="primary"></mat-spinner>
</div>
